import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyBBxnYElSmYFwsyXSvsDZH5wkyMXRbxpVg",
  authDomain: "amdtransportation-8d0a0.firebaseapp.com",
  projectId: "amdtransportation-8d0a0",
  storageBucket: "amdtransportation-8d0a0.firebasestorage.app",
  messagingSenderId: "159134604691",
  appId: "1:159134604691:web:c2bbcb377e0f2cf7df1c66",
  measurementId: "G-SFFPK3SYSK"
};

// const firebaseConfig = {
//   apiKey: "AIzaSyCgFj4NnkmWjpHVjY7psEYXfcS_EeFurlI",
//   authDomain: "tntresearchagent.firebaseapp.com",
//   projectId: "tntresearchagent",
//   storageBucket: "tntresearchagent.firebasestorage.app",
//   messagingSenderId: "868604882105",
//   appId: "1:868604882105:web:d8b96b54e7d66966343f68",
//   measurementId: "G-LQHD9VKQJS"
// };


const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);